import React from "react";
import { Box } from "@chakra-ui/react";
import { TextTitle } from "ui/text";
import { horizontalContainerPadding } from "ui/container";
import { ProgressTabs } from "ui/tabs";
import { sectionSpacingY } from "components/section";
import { audiencesTab, insightsTab, journeysTab, realTimeTab } from "components/product-screens/product-slideshow-tabs";

const tabs = [
  {
    id: "screen-tab-1",
    ...audiencesTab,
  },
  {
    id: "screen-tab-2",
    ...journeysTab,
  },
  {
    id: "screen-tab-3",
    ...realTimeTab,
  },
  {
    id: "screen-tab-4",
    ...insightsTab,
  },
];

export function ComposableCdpSlideshow({ isHidden }: { isHidden?: boolean }) {
  return (
    <Box
      display={isHidden ? "none" : "block"}
      as="section"
      maxW="container.section"
      mx="auto"
      px={horizontalContainerPadding}
      mt={{ base: "biggest", md: "huge" }}
      mb={sectionSpacingY}
    >
      <TextTitle
        theme="dark"
        align="center"
        size="lg"
        chip={{ text: "Composable Customer Data Platform" }}
        title="Self-service access to your best data for marketers"
        description="Everything you need to turn your existing data platform into a secure, intuitive CDP that any marketer can use for e-mail, advertising, CRM, and more."
        maxW="740px"
      />
      <ProgressTabs
        prerenderMedia={false}
        theme="dark"
        mt={{ base: "biggest", md: "bigger" }}
        mb={{ base: "huge", md: "biggest" }}
        tabs={tabs}
      />
    </Box>
  );
}
